






















import { Component, Mixins } from "vue-property-decorator";
import { DrawableItemEditorMixin } from "../mixins";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, TextDrawerPropertyEditableMixin, PainterPropertyEditableMixin } from "./mixins";
import TextStyleEditor from "../../../drawing/TextStyleEditor.vue";
import FillStyleEditor from "../../../drawing/FillStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";

@Component({
  components: {
    textStyleEditor: TextStyleEditor,
    fillStyleEditor: FillStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
  },
})
export default class TextPropertyEditor extends Mixins(PropertyEditableMixin, DrawableItemEditorMixin, DrawerPropertyEditableMixin, TextDrawerPropertyEditableMixin, PainterPropertyEditableMixin) {
}
